import UserService from 'Services/user';

export default {
	name: 'Confirm',
	created() {
		if (this.$store.state.user.isConfirmed === true) {
			this.$router.push({ name: 'devices', params: { snack: 'confirmed' } });
			return;
		}
		this.isLoading = true;
		UserService.confirm(this.$route.params.token)
			.then(response => {
				if (response.status === 200) {
					this.$store.commit('CONFIRM_USER');
					this.$router.push('/');
				}
			})
			.catch(error => {
				this.$router.push({ name: 'devices', params: { snack: 'error' } });
			})
			.finally(() => {
				this.isLoading = false;
			});
	},
	data() {
		return {
			isLoading: false
		};
	}
};



// WEBPACK FOOTER //
// ./app/components/confirm/script.js